$(".js-email-global-unsubscribe").change(function() {
  $(".js-email-list-receive").prop('checked', !this.checked);
});

$(".js-email-list-receive").change(function() {
  if(!this.checked) {
    // Checks if this was the last checkbox that was on, if so we need to toggle
    // the global unsubscribe
    if(!$(".js-email-list-receive").map(function(){ return this.checked }).get().includes(true)) {
      // No list is checked so check the global one
      $(".js-email-global-unsubscribe").prop('checked', true);
    }
  } else if ($(".js-email-global-unsubscribe").prop('checked')) {
      $(".js-email-global-unsubscribe").prop('checked', false);
  }
});

// Submit form
$(".js-email-preference-input").change(function() {
  $(".js-email-preference-form").submit();
  $(".js-email-preference-error").addClass('hidden');
  $(".js-email-preference-success").addClass('hidden');
  $(".js-email-preference-loading").removeClass('hidden');
});

$(".js-email-preference-form").bind('ajax:success',function(event, data, status, xhr) {
  $(".js-email-preference-loading").addClass('hidden');
  $(".js-email-preference-success").removeClass('hidden');
  var preferences = JSON.parse(data.mail_preference);
  $.each(preferences, function(key, value) {
    $(".js-email-preference-input[name='mail_preference["+ key +"]'")
      .prop("checked", value);
  });
});

$(".js-email-preference-form").bind('ajax:error',function() {
  $(".js-email-preference-loading").addClass('hidden');
  $(".js-email-preference-error").removeClass('hidden');
});
